export default __webpack_public_path__ + "static/media/sorting-icon.492e54b1.svg";